import apiFetch from '@wordpress/api-fetch';
import type {SearchItem, SearchQuery} from '@wordpress/api/search';
import {__} from '@wordpress/i18n';


/**
 * Fetch items from the search endpoint.
 */
export async function fetchItems(
	search: string,
	type: 'post' | 'term',
	subType: string,
	include?: number[],
	exclude?: number[]
): Promise<SearchItem[]> {
	try {
		const params: { [key in keyof SearchQuery]: string } = {
			per_page: '20',
			type,
			subtype: subType,
		};
		if ( '' !== search ) {
			params.search = search;
		}

		if ( exclude !== undefined && exclude.length > 0 ) {
			params.exclude = exclude.join( ',' );
		}

		if ( include !== undefined && include.length > 0 ) {
			params.include = include.join( ',' );
		} else if ( '' === search ) {
			// No search nor include, do not make a request.
			return [];
		}

		const url = '/wp/v2/search?' + new URLSearchParams( params ).toString();

		return await apiFetch<SearchItem[]>( {
			method: 'GET',
			path: url,
		} );
	} catch ( e ) {
		console.error( e );
		throw new Error( __( `Unable to search for items.`, 'advanced-sidebar-menu' ) );
	}
}
